import React from 'react';
import { PropTypes } from 'prop-types';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import * as Yup from 'yup';

import SubmitButton from '@atoms/SubmitButton';
import Radios from '@atoms/Radios';
import CheckboxGroup from '@atoms/CheckboxGroup';
import LoadingInline from '@molecules/LoadingInline';
import { BodyLarge, DividerLightGreyStyled, H4, LabelSmall } from '@styled';

import { regionList } from '@general/helpers/regions.helpers';

const InterestContainer = styled.div`
    margin-bottom: 40px;
`;

const StepOne = ({ data, onNext, loading }) => (
    <div>
        <div className="mb-1rem">
            <LabelSmall>Step 1 of 3</LabelSmall>
        </div>

        <H4 className="mb-3">What are you looking to do?</H4>

        <DividerLightGreyStyled className="mt-0.5rem mb-2rem" />

        {loading || !data ? (
            <LoadingInline />
        ) : (
            <>
                <div className="mb-2rem">
                    <BodyLarge>
                        Select your interest and location to open up better matchmaking opportunities.
                    </BodyLarge>
                </div>

                <Formik
                    onSubmit={onNext}
                    initialValues={data}
                    enableReinitialize
                    validationSchema={Yup.object().shape({
                        primaryInterest: Yup.string()
                            .nullable(true)
                            .required('Please select a primary interest.'),
                        businessLocations: Yup.array()
                            .of(Yup.string())
                            .required('Please select a business location.'),
                    })}
                >
                    {({ values, errors, isValid, submitCount }) => (
                        <Form errors={errors}>
                            {!isValid && submitCount > 0 && (
                                <div className="alert alert-danger">There were issues with your submission.</div>
                            )}

                            <InterestContainer>
                                <Radios
                                    label="What are you interested in?"
                                    name="primaryInterest"
                                    instructions="Select one."
                                    value={values.primaryInterest}
                                    options={[
                                        { value: 'TENANTS', label: 'Finding tenants' },
                                        { value: 'SPACE', label: 'Finding space' },
                                        { value: 'CONNECTIONS', label: 'Networking with others' },
                                        {
                                            value: 'PRODUCTS',
                                            label: 'Looking for or providing products and services',
                                        },
                                    ]}
                                    required
                                />
                            </InterestContainer>

                            <CheckboxGroup
                                label="What location(s) do you do business in?"
                                name="businessLocations"
                                instructions="Check all that apply."
                                options={Object.keys(regionList).map(regionKey => {
                                    const region = regionList[regionKey];
                                    const tooltip =
                                        (region.subregions || []).length > 0
                                            ? region.subregions.map(subregion => subregion.name).join('<br />')
                                            : null;

                                    return {
                                        value: regionKey,
                                        label: region.label,
                                        tooltip,
                                    };
                                })}
                                required
                            />
                            <SubmitButton isDisabled={!isValid}>Save & Proceed</SubmitButton>
                        </Form>
                    )}
                </Formik>
            </>
        )}
    </div>
);

StepOne.propTypes = {
    data: PropTypes.object,
    onNext: PropTypes.func,
    loading: PropTypes.bool,
};

export default StepOne;
